<template>
  <validation-observer
    ref="validator"
    v-slot="{ invalid }"
    tag="div"
    class="validator"
  >
    <pop-up
      :button-text="groupId ? 'Update' : 'Create'"
      class="top-fade-in"
      :spinning="addingHealthcheckGroup || updatingHealthcheckGroup"
      :disabled="invalid"
      @add="onSubmit"
      @close="$emit('close')"
    >
      <template #title>
        {{ groupId ? 'Update' : 'Create a new' }} healthcheck group
        <a
          v-b-popover.hover.focus="'Set group as favorite to show on top of the rest when selecting a group.'"
          class="text-yellow"
          @click="isDefault = !isDefault"
        >
          <GjIcon
            :key="`favorite${isDefault}`"
            :name="isDefault ? 'Star_fill' : 'Star'"
            size="20"
          />
        </a>
      </template>
      <div class="position-relative">
        <div
          v-if="groupId && gettingHealthcheckGroup"
          class="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
          style="top: 0;"
        >
          <b-spinner
            small
            variant="primary"
          />
        </div>
        <validation-provider
          #default="{ errors }"
          name="Name"
          rules="required|min:3|max:100"
        >
          <input-field
            label="Group Name*"
            label-position="top"
            :error="errors.length ? errors[0] : null"
            class="name"
          >
            <b-form-input
              v-model="name"
              :state="errors.length > 0 ? false : null"
              placeholder="Enter group name here..."
            />
          </input-field>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          name="Description"
          rules="max:200"
        >
          <input-field
            label="Description"
            label-position="top"
            class="name"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-textarea
              v-model="description"
              placeholder="Enter group description here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>
      </div>
    </pop-up>
  </validation-observer>
</template>
<script>
import PopUp from '@/components/popup/Pop-up.vue'

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'HealthcheckGroupForm',
  components: { PopUp, ValidationObserver, ValidationProvider },
  props: {
    groupId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      required,
      name: '',
      description: '',
      isDefault: false,
    }
  },
  computed: {
    gettingHealthcheckGroup() {
      return this.$store.state.healthchecks.gettingHealthcheckGroup
    },
    addingHealthcheckGroup() {
      return this.$store.state.healthchecks.addingHealthcheckGroup
    },
    updatingHealthcheckGroup() {
      return this.$store.state.healthchecks.updatingHealthcheckGroup
    },
    healthcheckGroup() {
      return this.$store.state.healthchecks.healthcheckGroup
    },
  },
  created() {
    if (this.groupId) {
      this.$store
        .dispatch('healthchecks/getHealthcheckGroup', this.groupId)
        .then(() => {
          this.name = this.healthcheckGroup.name
          this.description = this.healthcheckGroup.description
          this.isDefault = this.healthcheckGroup.isDefault
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating healthcheck group.')
        })
    }
  },
  methods: {
    onSubmit() {
      const group = {
        name: this.name,
        description: this.description,
        isDefault: this.isDefault,
      }
      if (this.groupId) {
        this.$store
          .dispatch('healthchecks/updateHealthcheckGroup', {
            id: this.groupId,
            group,
          })
          .then(() => {
            this.successToast('Healthcheck group was updated.')
            this.$emit('close')
          })
          .catch(error => {
            this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating healthcheck group.')
          })
      } else {
        this.$store
          .dispatch('healthchecks/addHealthcheckGroup', group)
          .then(() => {
            this.successToast('Healthcheck group was created.')
            this.$emit('groupAdded')
          })
          .catch(error => {
            this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating healthcheck group.')
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.text-yellow {
  color: var(--yellow) !important;
}
</style>
